




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Cognito from "@/authorization/cognito";
import {CognitoUser} from "amazon-cognito-identity-js";
import Translate from "@/consoleapi/api/translate";

@Component
export default class BillingInfoConfirm extends Vue {
    @Prop() userId!: string;
    @Prop() public cognito!: Cognito;
    @Prop() public cognitoUser!: CognitoUser;

    private code = '';
    private newPassword = '';

    doConfrim(event: Event){
        if (event) {
            event.preventDefault()
        }
        // console.log(this.cognitoUser.getUsername() + "," + this.code + ',' + this.newPassword);
        this.cognito.confirmForgotPassword(this.cognitoUser, this.code, this.newPassword).then(result => {
            this.$router.push('sign-in');
        }).catch(err => {
            this.translate(err.message || JSON.stringify(err));
            return;
        });
    }

    translate(message: string) {
        const translate = new Translate();
        translate.get(message)
            .then(response => {
                alert(response.data.text);
            })
            .catch(error => {
                //console.log(error.response);
                alert(message);
            })
    }
}
